'use client'

import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

import SectionCta, { BlackCta, FloatingCta } from '@components/Button/button'
import BusinessModals from '@components/BusinessModal/businessModals'
import { isNonBlankString } from '@utils/stringUtils'

type BottomFloaterCtaProps = {
  data: {
    formSnippet?: unknown
  }
  segmentEventCommonProperties?: Record<string, unknown>
  variant?: 'default' | 'black' | 'floating'
}

const BusinessModalPortal = ({ formSnippet, isModalOpen, setIsModalOpen }) => {
  const [portalTarget, setPortalTarget] = useState<HTMLElement | null>(null)

  useEffect(() => {
    setPortalTarget(document.body)
  }, [])

  if (!formSnippet || !portalTarget) return null

  return createPortal(
    <BusinessModals isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} content={formSnippet} />,
    portalTarget
  )
}

const BottomFloaterCta = ({ data, segmentEventCommonProperties, variant = 'default' }: BottomFloaterCtaProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const formSnippet = isNonBlankString(data?.formSnippet) ? data.formSnippet : ''
  const handleBusinessModalClick = formSnippet ? () => setIsModalOpen(true) : undefined
  const ctaProps = {
    data,
    segmentEventCommonProperties,
    onClick: handleBusinessModalClick,
  }

  return (
    <>
      {variant === 'black' ? (
        <BlackCta {...ctaProps} />
      ) : variant === 'floating' ? (
        <FloatingCta {...ctaProps} />
      ) : (
        <SectionCta {...ctaProps} />
      )}
      <BusinessModalPortal formSnippet={formSnippet} isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
    </>
  )
}

export default BottomFloaterCta
